import { render, staticRenderFns } from "./AnalysesHeroSection.vue?vue&type=template&id=a0a5d522&scoped=true&"
import script from "./AnalysesHeroSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AnalysesHeroSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AnalysesHeroSection.vue?vue&type=style&index=0&id=a0a5d522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a5d522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0a5d522')) {
      api.createRecord('a0a5d522', component.options)
    } else {
      api.reload('a0a5d522', component.options)
    }
    module.hot.accept("./AnalysesHeroSection.vue?vue&type=template&id=a0a5d522&scoped=true&", function () {
      api.rerender('a0a5d522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesHeroSection.vue"
export default component.exports